export class WorkObjectAnalysesOptions {
    grouper: string;
    filter: string;
    findDuplicates = false;
    selectFields: string[];
    collectValues: string;
}
